import {ReactElement} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {Utils} from "components/src/utils/Utils";

const MAX_FILENAME_LENGTH = 30;

interface AttachmentsProps {
    attachments: { name: string; size?: number }[];
    dropdownItemText: string;
    onDropdownItemClick: (index: number) => void;
    icon: ReactElement;
}

/**
 * Displays a list of attachment chips in a wrapping flex row.
 * Long filenames are truncated to MAX_FILENAME_LENGTH characters with a tooltip showing the full name.
 * Each chip has a dropdown menu with a single configurable action (e.g. remove or download).
 */
export const Attachments = ({attachments, dropdownItemText, onDropdownItemClick, icon}: AttachmentsProps) =>
{
    if (attachments.length === 0) {
        return null;
    }

    return (
        <div className="d-flex flex-wrap gap-2 mt-2">
            {attachments.map((attachment, index) => (
                <div key={index}
                     className="d-flex align-items-center border rounded px-2 py-2">
                    <Dropdown>
                        <Dropdown.Toggle variant="link" size="sm"
                                         className="p-0 border-0 text-secondary d-flex align-items-center">
                            {attachment.name.length > MAX_FILENAME_LENGTH ? (
                                <OverlayTrigger placement="top"
                                                overlay={<Tooltip>{attachment.name}</Tooltip>}>
                                    <span className="me-1">{attachment.name.substring(0, MAX_FILENAME_LENGTH)}…</span>
                                </OverlayTrigger>
                            ) : (
                                <span className="me-1">{attachment.name}</span>
                            )}
                            {attachment.size !== undefined &&
                                <span className="text-body-tertiary ms-1" style={{fontSize: '0.8em'}}>
                                    ({Utils.formatBytes(attachment.size)})
                                </span>
                            }
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => onDropdownItemClick(index)}>
                                {icon} {dropdownItemText}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ))}
        </div>
    );
};
